export interface ResetPasswordFormData {
    password: string,
    passwordRepeat: string,
    pincode: string,
    pincodeRepeat: string,
}

export const queryParamApiTokenKey = 'api_token'
export const queryParamUserUuidKey = 'user_uuid'
